export class SkechersComparisonReq {
    poNumber?: string;
    splitPo?: string;
    totalQuantity: string;
    splitPoTotalQuantity?: string;
    style?: string
    color?: string
    deliveryDateStartDate?: any
    deliveryDateEndDate?: any
    itemNo?: string;

    constructor(poNumber?: string,
        splitPo?: string,
        totalQuantity?: string,
        splitPoTotalQuantity?: string,
        style?: string,
        color?: string,
        deliveryDateStartDate?: any,
        deliveryDateEndDate?: any,
        itemNo?: string,

    ) {
        this.poNumber = poNumber;
        this.splitPo = splitPo;
        this.totalQuantity = totalQuantity;
        this.splitPoTotalQuantity = splitPoTotalQuantity;
        this.color = color
        this.style = style
        this.deliveryDateEndDate = deliveryDateEndDate
        this.deliveryDateStartDate = deliveryDateStartDate
        this.itemNo = itemNo
    }
}